export interface TrustedByConfigItem {
  id: string;
  name?: string;
  role?: string;
  company: string;
  description: string;
  logoUrl: string;
}

export const trustedByConfig: TrustedByConfigItem[] = [
  {
    id: '1inch',
    name: 'Ivan',
    company: '1inch',
    description:
      'Our relationship with Magic Square has consistently delivered outstanding results, enhancing our overall Web3 journey.',
    logoUrl: '/magicsquare/landing/logo/1inch.png',
  },
  {
    id: 'funtico',
    name: 'Antohe Pavel',
    company: 'Funtico',
    role: 'CPO',
    description: `Working with Magic Square was one of the smoothest collaboration that this crazy web3 space can offer you! Top notch professionals, pro-active mindset and always there to make the most from any possible angle! \n The other cool part is that they completely tailor made the campaigns based on our needs, not just a general template, that 9/10 times, it brings no results.`,
    logoUrl: '/magicsquare/landing/logo/funtico.png',
  },
  {
    id: 'nicegram',
    name: 'Anastasia',
    company: 'Nicegram',
    role: 'Social & Community Manager',
    description: `Working with Magic Square has been productive. The team quickly and efficiently organizes campaigns that deliver results, and they are always ready to offer individual solutions to any request.`,
    logoUrl: '/magicsquare/landing/logo/nicegram.png',
  },
  {
    id: 'vampire',
    name: 'Anastasiya',
    company: 'dEmpire of Vampire',
    role: 'Content Manager',
    description: `Hello! We are quite satisfied with it! We saw that our game is interesting to your community as almost 90% of people completed more tasks than we asked :) besides, we were glad to receive good vibes from your community during the AMAs!  Thanks!`,
    logoUrl: '/magicsquare/landing/logo/vampire.png',
  },
  {
    id: '5tars',
    name: 'Borja G. Puado',
    company: '5TARS',
    role: 'Head Marketing & Growth',
    description: `Our partnership with Magic Square has been transformative. Their platform and community have boosted user engagement, and with their support, we've expanded our market presence.`,
    logoUrl: '/magicsquare/landing/logo/5tars.png',
  },
  {
    id: 'arenaGames',
    name: 'Giorgi',
    company: 'Arena Games',
    role: 'Web3 Marketer',
    description: `Magic Square made it easy. Their karma points helped us find gamers who value our game as much as we do. With their help, our Grand Tournament attracted over a thousand gamers, creating a buzz, and stood out as a community favorite. It felt less like marketing and more like community building. They've set a new measure for web3 events, where quality and enthusiasm meet scale.`,
    logoUrl: '/magicsquare/landing/logo/arenaGames.png',
  },
  {
    id: 'yomiGames',
    name: 'Jason',
    company: 'YOMI GAMES',
    role: 'CEO',
    description: `Probably one of our most effective campaigns based on both user growth and retentive users.`,
    logoUrl: '/magicsquare/landing/logo/yomiGames.png',
  },
  {
    id: 'memeFighter',
    name: 'Meme Jedi',
    company: 'Meme Fighter AI',
    role: 'Business Development',
    description: `The Magic Square Hot Offer campaign played a key role in attracting new gamers during our Meme Fighter Match eSports tournament.\nWorking with the Magic Square crew was a breeze—they were super professional, flexible and made the whole thing come together smoothly.`,
    logoUrl: '/magicsquare/landing/logo/memeFighter.png',
  },
  {
    id: 'machinesArena',
    name: 'Giorgio Crosali',
    company: 'The Machines Arena',
    role: 'Marketing Producer',
    description: `Magic Square helped us grow The Machines Arena community with clear, measurable results. Their CPA campaigns, tailored specifically to our game's metrics and combined with their ability to attract high-retention users, made them stand out from other UA partners in the GameFi space.`,
    logoUrl: '/magicsquare/landing/logo/machinesArena.png',
  },
  {
    id: 'exSports',
    name: 'Nemo',
    company: 'EX Sports',
    role: 'Marketing & Social Manager',
    description: `The hot offers have been fantastic, especially because we've been focusing on different outcomes and they've all worked great. The very first campaign we did was the best one we had, driving thousands of app downloads and new users, and the campaigns focused on players for the games have been really good as well.\nI am quite pleased actually with Magic and it is one of the most successful task/quest platforms and the users are good and trustworthy. Definitely would stick with Magic.`,
    logoUrl: '/magicsquare/landing/logo/exSports.png',
  },
  {
    id: 'echoOfTheHorizon',
    name: 'Sava Tesanovic',
    company: 'Echo of the Horizon',
    role: 'CEO & Founder',
    description: `Magic Square has been fantastic for us. We've seen significant growth in our email list and wishlist, and our active player base has increased by 40% for the duration of our campaign. We couldn't be more pleased!`,
    logoUrl: '/magicsquare/landing/logo/echoOfTheHorizon.png',
  },
  {
    id: 'epikoMarket',
    name: 'Gagandeep Singh',
    company: 'Epiko Market',
    role: 'CMO',
    description: `Collaborating with Magic Square for our recent Epiko campaign was a seamless experience. Their structured onboarding process helped us acquire users who completed all required tasks. The Magic Square team was responsive and proactive in resolving challenges, ensuring a smooth user journey. Their analytics and verification process also provided clear insights, making reward distribution seamless. We appreciate the collaboration and look forward to scaling future campaigns together.`,
    logoUrl: '/magicsquare/landing/logo/epikoMarket.png',
  },
  {
    id: 'sociogram',
    company: 'Sociogram',
    role: 'CMO',
    description: `Our collaboration with Magic Square proved to be a rewarding experience. Their services were not only efficient but also delivered with a high degree of comfort for the event management. The results we achieved surpassed our initial projections, exceeding our expectations. We recommend Magic Square, as they provide a comprehensive solutions, cost-effective event management, and stellar traction.`,
    logoUrl: '/magicsquare/landing/logo/sociogram.png',
  },
  {
    id: 'cryptoHunters',
    name: 'S4NT',
    company: 'Crypto Hunters',
    role: 'Partnership Manager',
    description: `Henrich, tbh everything was always perfect, really professional and all sorted really fast and good always! like literally 100%.`,
    logoUrl: '/magicsquare/landing/logo/cryptoHunters.png',
  },
  {
    id: 'sensayAI',
    name: 'Kevan',
    company: 'Sensay AI',
    role: 'Web3 Marketing',
    description: `The Magic Square team is a highly skilled and professional group, dedicated to excellence in their work. They form a dynamic community that can assist in elevating your product to its fullest potential.`,
    logoUrl: '/magicsquare/landing/logo/sensayAI.png',
  },
  {
    id: 'wilderWorld',
    name: 'Zen',
    company: 'Wilder World',
    role: 'Head of Partnerships',
    description: `Magic Square's team has been one of the best collaboration partners for UA, always responsive, proactive, and willing to go above and beyond.\nTheir community is authentic, real gamers and has delivered real impact.`,
    logoUrl: '/magicsquare/landing/logo/wilderWorld.png',
  },
  {
    id: 'credefiFinance',
    name: 'Ivo Grigorov',
    company: 'Credefi Finance',
    role: 'CEO',
    description: `Partnering with Magic Square has been a truly rewarding experience for Credefi. The Magic Store is one of a kind — a curated hub that connects us with real, engaged users who are genuinely interested in what we offer. Their tailor-made campaigns delivered tangible, measurable results, going beyond surface-level exposure. The combination of smart targeting and a supportive team made a real impact on our growth.`,
    logoUrl: '/magicsquare/landing/logo/credefiFinance.png',
  },
  {
    id: 'bitHotel',
    name: 'Leon',
    company: 'Bit Hotel',
    role: 'COO',
    description: `Magic Square has a streamlined process for questmaking on their platform and an active community that loves to explore. Highly recommend any founder to give it a shot.`,
    logoUrl: '/magicsquare/landing/logo/bitHotel.png',
  },
  {
    id: 'foxsyAI',
    name: 'Sebastian Marian',
    company: 'Foxsy AI',
    role: 'CEO & Co-Founder',
    description: `The collaboration with Magic Square, has brought exactly the dose of awareness needed to push the Foxsy AI bootstrapping phase, to that threshold where just a little spark could trigger an unstoppable rolling ball.`,
    logoUrl: '/magicsquare/landing/logo/foxsyAI.png',
  },
  {
    id: 'ORGANYA',
    name: 'Ricardo',
    company: 'ORGANYA',
    role: 'VP Marketing & Strategy',
    description: `Communication -> fantastic\nAdaptability and professionalism -> high as always\nResults -> as expected, we are happy with them\nOrganization -> exceptionally, it's extremely easy to work with you\nAlthough we do not have more campaigns planned yet, we will surely keep working with you guys.`,
    logoUrl: '/magicsquare/landing/logo/ORGANYA.png',
  },
];
